function ensureFreeGiftGlobals() {
  if (typeof window.fetchConfig !== 'function') {
    window.fetchConfig = function fetchConfig(type = 'json') {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
      };
    };
  }
  const root = window.Shopify?.routes?.root || '/';
  window.routes = window.routes || {};
  window.routes.cart_url = window.routes.cart_url || `${root}cart`;
  window.routes.cart_add_url = window.routes.cart_add_url || window.Eurus?.cart_add_url || `${root}cart/add.js`;
  window.routes.cart_change_url = window.routes.cart_change_url || `${root}cart/change.js`;
}
ensureFreeGiftGlobals();

class FreeGiftController {
  constructor(config) {
    this.config = config;
    this.qualifyingIds = new Set((config.cartQualifyingIds || []).map(String).filter(Boolean));
    this.dialog = document.getElementById('FreeGiftDialog');
    this.image = document.getElementById('FreeGiftDialogImage');
    this.optionsEl = document.getElementById('FreeGiftOptions');
    this.submitButton = document.getElementById('FreeGiftSubmit');
    this.errorEl = document.getElementById('FreeGiftError');
    this.priceEl = document.getElementById('FreeGiftDialogPriceOriginal');
    this.selectedOptions = [];
    this.syncing = false;
    this.syncQueued = false;
    this.dismissed = false;
    this.checkoutResolver = null;
    this.allowNativeCheckout = false;
    this.mode = 'add';
    this.activeGiftVariants = this.config.variants || [];
    this.updatingFromGift = false;
    this.pickerPending = false;
    this.pickerConfirmed = Boolean(config.hasGift);
    this.hadGift = Boolean(config.hasGift);
    this.giftRemovedByBuyer = false;

    this.harvestQualifyingIds();
    this.activeGiftVariants = this.config.variants || [];
    this.buildOptions();
    this.bindDialog();
    this.bindPrompts();
    this.wrapGokwik();
    this.wrapPandaCart();
    this.bindQualifyingAdd();
    this.bindGiftRemove();
    this.bindPdpBanner();
    if (this.dialog) document.body.appendChild(this.dialog);

    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source === 'free-gift') return;
        this.harvestQualifyingIds();
        const addedId = event?.productVariantId ? String(event.productVariantId) : '';
        if (addedId) {
          document.querySelectorAll('[data-free-gift-qualifying]').forEach((el) => {
            const ids = String(el.getAttribute('data-free-gift-qualifying') || '')
              .split(',')
              .map((id) => id.trim())
              .filter(Boolean);
            if (ids.includes(addedId)) this.qualifyingIds.add(addedId);
          });
        }
        const qualifies = Boolean(addedId && this.qualifyingIds.has(addedId));
        if (qualifies) {
          this.dismissed = false;
          this.openPickerAfterQualifyingAdd();
          return;
        }
        this.sync({ openPickerIfNeeded: true });
      });
    }

    document.addEventListener('click', (event) => {
      const changeBtn = event.target.closest('[data-free-gift-change]');
      const promptBtn = event.target.closest('[data-free-gift-open]');
      if (changeBtn) {
        event.preventDefault();
        this.openPicker({ mode: 'change' });
      } else if (promptBtn) {
        event.preventDefault();
        this.openPicker({ mode: 'add' });
      }
    });

    document.addEventListener('eurus:cart:items-changed', (event) => {
      if (this.updatingFromGift || event?.detail?.source === 'free-gift') return;
      this.harvestQualifyingIds();
      if (this.pickerPending) this.hidePandaCart();
      clearTimeout(this.syncTimer);
      this.syncTimer = setTimeout(async () => {
        try {
          await this.waitForPandaCart();
        } catch (error) {}
        this.sync({ openPickerIfNeeded: true });
      }, 350);
    });

    this.sync({ openPickerIfNeeded: false });
  }

  pandaCartHelper() {
    return window.Alpine?.store?.('xCartHelper');
  }

  async waitForPandaCart() {
    const wait = this.pandaCartHelper()?.waitForCartUpdate;
    if (typeof wait !== 'function') return;
    await Promise.race([
      wait.call(this.pandaCartHelper()),
      new Promise((resolve) => setTimeout(resolve, 1500)),
    ]);
  }

  shouldBlockCart() {
    return Boolean(this.pickerPending || this.dialog?.open);
  }

  wrapPandaCart() {
    const tryWrap = () => {
      const alpine = window.Alpine;
      if (!alpine?.store) return false;
      const miniCart = alpine.store('xMiniCart');
      if (miniCart?.openCart && !miniCart.openCart._freeGiftWrapped) {
        const originalOpen = miniCart.openCart.bind(miniCart);
        const controller = this;
        const wrapped = function wrappedOpenCart() {
          if (controller.shouldBlockCart()) return;
          return originalOpen();
        };
        wrapped._freeGiftWrapped = true;
        miniCart.openCart = wrapped;
      }
      const cartNoti = alpine.store('xCartNoti');
      if (cartNoti?.setItem && !cartNoti.setItem._freeGiftWrapped) {
        const originalSet = cartNoti.setItem.bind(cartNoti);
        const controller = this;
        const wrappedSet = function wrappedSetItem() {
          if (controller.shouldBlockCart()) return;
          return originalSet.apply(this, arguments);
        };
        wrappedSet._freeGiftWrapped = true;
        cartNoti.setItem = wrappedSet;
      }
      if (cartNoti?.open && !cartNoti.open._freeGiftWrapped) {
        const originalNotiOpen = cartNoti.open.bind(cartNoti);
        const controller = this;
        const wrappedNotiOpen = function wrappedNotiOpen() {
          if (controller.shouldBlockCart()) return;
          return originalNotiOpen.apply(this, arguments);
        };
        wrappedNotiOpen._freeGiftWrapped = true;
        cartNoti.open = wrappedNotiOpen;
      }
      return Boolean(miniCart?.openCart?._freeGiftWrapped);
    };

    if (!tryWrap()) {
      document.addEventListener('alpine:init', tryWrap);
      document.addEventListener('alpine:initialized', tryWrap);
      setTimeout(tryWrap, 0);
      setTimeout(tryWrap, 300);
    }
  }

  bindQualifyingAdd() {
    const markIfQualifying = (host, form) => {
      const ids = String(
        host?.getAttribute?.('data-free-gift-qualifying') ||
          form?.getAttribute?.('data-free-gift-qualifying') ||
          ''
      )
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
      if (!ids.length) return false;
      const idInput = (form || host)?.querySelector?.('input[name="id"], input.product-variant-id');
      const variantId = idInput?.value ? String(idInput.value) : '';
      if (!variantId || !ids.includes(variantId)) return false;
      this.qualifyingIds.add(variantId);
      this.pickerPending = true;
      this.dismissed = false;
      document.documentElement.classList.add('free-gift-picker-open');
      this.hidePandaCart();
      clearTimeout(this.pickerPendingTimer);
      this.pickerPendingTimer = setTimeout(() => {
        if (this.pickerPending && !this.dialog?.open) {
          this.pickerPending = false;
          document.documentElement.classList.remove('free-gift-picker-open');
        }
      }, 10000);
      return true;
    };

    document.addEventListener(
      'click',
      (event) => {
        const trigger = event.target.closest(
          'button[name="add"], .add_to_cart_button, button.add_to_cart_button'
        );
        if (!trigger || trigger.closest('#FreeGiftDialog')) return;
        const form = trigger.closest('form');
        const host = trigger.closest('product-form') || form;
        markIfQualifying(host, form);
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
        const host = form.closest('product-form') || form;
        markIfQualifying(host, form);
      },
      true
    );
  }

  bindGiftRemove() {
    document.addEventListener(
      'click',
      (event) => {
        const row = event.target.closest('.cart-item--free-gift, [data-free-gift-line="true"]');
        if (!row) return;
        if (!event.target.closest('button, a, [role="button"]')) return;
        this.giftRemovedByBuyer = true;
        this.pickerConfirmed = false;
        this.dismissed = false;
      },
      true
    );
  }

  updatePdpBanners(variantId) {
    const id = String(variantId || '');
    const giftAlreadyInCart = Boolean(this.hadGift);
    document.querySelectorAll('[data-free-gift-pdp-banner]').forEach((banner) => {
      const ids = String(banner.getAttribute('data-free-gift-qualifying') || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
      banner.hidden = giftAlreadyInCart || !(id && ids.includes(id));
      this.fillPdpGiftPreview(banner, id);
    });
    this.placePdpBanner();
  }

  refreshPdpBanner() {
    const id =
      document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value
      || document.querySelector('product-form input[name="id"]')?.value
      || '';
    this.updatePdpBanners(id);
  }

  pdpProductVariants(banner) {
    const node = banner?.querySelector('[data-free-gift-pdp-product-variants]');
    if (!node) return [];
    try {
      const parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  listingCardMatchValues() {
    const values = new Set();
    const card = this.findStandardPriceCard();
    if (!card) return values;
    const add = (value) => {
      const normalized = this.normalizeValue(value);
      if (normalized) values.add(normalized);
    };
    card.querySelectorAll('select').forEach((select) => {
      add(select.value);
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption) add(selectedOption.textContent);
    });
    card.querySelectorAll('input:checked, [aria-checked="true"], [aria-selected="true"]').forEach((el) => {
      add(el.value);
      add(el.getAttribute('data-value'));
      add(el.textContent);
    });
    return values;
  }

  pdpMatchValues() {
    const listing = this.listingCardMatchValues();
    if ([...listing].some((value) => !this.isGenericMatchValue(value))) return listing;
    const values = new Set();
    const add = (value) => {
      const normalized = this.normalizeValue(value);
      if (normalized) values.add(normalized);
    };
    document.querySelectorAll('.product-form__input input:checked, fieldset.product-form__input input:checked').forEach((input) => {
      add(input.value);
    });
    document.querySelectorAll('.product-form__input select').forEach((select) => {
      add(select.value);
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption) add(selectedOption.textContent);
    });
    return values;
  }

  matchingGiftForPdp(variantId) {
    const allowed = this.config.variants || [];
    if (!allowed.length) return null;
    const banner = document.querySelector('[data-free-gift-pdp-banner]');
    const listingNeedles = new Set(
      [...this.listingCardMatchValues()].filter((value) => !this.isGenericMatchValue(value))
    );
    const needles = new Set(listingNeedles);
    if (!needles.size) {
      const addNeedles = (values) => {
        values.forEach((value) => {
          if (!this.isGenericMatchValue(value)) needles.add(this.normalizeValue(value));
        });
      };
      const selected = this.pdpProductVariants(banner).find((variant) => String(variant.id) === String(variantId));
      if (selected) {
        addNeedles(selected.options || []);
        String(selected.title || '')
          .split('/')
          .forEach((part) => addNeedles([part]));
      }
      addNeedles(this.pdpMatchValues());
    }
    if (!needles.size) return null;
    const giftValuesOf = (variant) =>
      [...(variant.options || []), ...String(variant.title || '').split('/')]
        .map((value) => this.normalizeValue(value))
        .filter((value) => value && !this.isGenericMatchValue(value));
    const matched = allowed.filter((variant) => giftValuesOf(variant).some((value) => needles.has(value)));
    if (!matched.length) return null;
    if (matched.length === 1) return matched[0];
    const longestNeedle = [...needles].sort((a, b) => b.length - a.length)[0];
    const byLongest = matched.filter((variant) => giftValuesOf(variant).includes(longestNeedle));
    if (byLongest.length === 1) return byLongest[0];
    const exact = (byLongest.length ? byLongest : matched).find((variant) =>
      giftValuesOf(variant).every((value) => needles.has(value))
    );
    return exact || byLongest[0] || null;
  }

  fillPdpGiftPreview(banner, variantId) {
    const preview = banner.querySelector('[data-free-gift-pdp-preview]');
    if (!preview) return;
    if (banner.hidden) {
      preview.hidden = true;
      return;
    }
    const gift = this.matchingGiftForPdp(variantId);
    const title = this.config.productTitle || '';
    if (!gift && !title) {
      preview.hidden = true;
      return;
    }
    preview.hidden = false;
    const image = preview.querySelector('[data-free-gift-pdp-image]');
    const titleEl = preview.querySelector('[data-free-gift-pdp-title]');
    const variantEl = preview.querySelector('[data-free-gift-pdp-variant]');
    const imageUrl = gift?.featuredImage || this.config.featuredImage || '';
    if (image) {
      if (imageUrl) {
        image.src = imageUrl;
        image.alt = title || '';
        image.hidden = false;
      } else {
        image.removeAttribute('src');
        image.hidden = true;
      }
    }
    if (titleEl) titleEl.textContent = title;
    const variantTitle = gift?.title && gift.title !== 'Default Title' ? gift.title : '';
    if (variantEl) {
      variantEl.textContent = variantTitle;
      variantEl.hidden = !variantTitle;
    }
    const priceRow = preview.querySelector('[data-free-gift-pdp-price]');
    const originalEl = preview.querySelector('[data-free-gift-pdp-price-original]');
    const money = gift?.price || this.config.price || '';
    if (originalEl) originalEl.textContent = money;
    if (priceRow) priceRow.hidden = !money;
  }

  findStandardPriceCard() {
    const root = document.querySelector('.main-product');
    if (!root) return null;
    const nodes = [...root.querySelectorAll('div, article, section, li, shopify-block, fieldset')];
    const cards = nodes.filter((el) => {
      const text = el.textContent || '';
      if (!/standard price/i.test(text)) return false;
      if (/frequently bought together/i.test(text)) return false;
      return Boolean(el.querySelector('select, [role="combobox"], input[type="radio"]'));
    });
    if (!cards.length) return null;
    return cards.reduce((smallest, el) => (el.innerHTML.length < smallest.innerHTML.length ? el : smallest));
  }

  findFbtAnchor() {
    const root = document.querySelector('.main-product');
    if (!root) return null;
    const elements = root.querySelectorAll('h1, h2, h3, h4, p, span, div, legend');
    for (const el of elements) {
      const text = String(el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^frequently bought together$/i.test(text)) return el;
    }
    return root.querySelector('.x-block-fbt');
  }

  placePdpBanner() {
    if (this._placingBanner) return;
    this._placingBanner = true;
    try {
      const banners = [...document.querySelectorAll('[data-free-gift-pdp-banner]')];
      if (!banners.length) return;
      const banner = banners[0];
      banners.slice(1).forEach((el) => el.remove());

      const card = this.findStandardPriceCard();
      if (card) {
        if (card.nextElementSibling !== banner) card.after(banner);
      } else {
        const fbt = this.findFbtAnchor();
        if (fbt) {
          let anchor = fbt;
          while (
            anchor.parentElement &&
            anchor.parentElement.childElementCount === 1 &&
            /frequently bought together/i.test(anchor.parentElement.textContent || '') &&
            !/standard price/i.test(anchor.parentElement.textContent || '')
          ) {
            anchor = anchor.parentElement;
          }
          if (anchor.previousElementSibling !== banner) anchor.before(banner);
        }
      }

      if (this.findStandardPriceCard() || /standard price/i.test(document.querySelector('.main-product')?.innerText || '')) {
        document.querySelectorAll('.main-product .x-variant-picker.variant-selects-main').forEach((picker) => {
          picker.setAttribute('hidden', '');
          picker.style.display = 'none';
        });
      }
    } finally {
      this._placingBanner = false;
    }
  }

  bindPdpBanner() {
    const readSelectedId = () =>
      document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value
      || document.querySelector('product-form input[name="id"]')?.value
      || '';

    this.updatePdpBanners(readSelectedId());
    [300, 800, 1600].forEach((delay) => window.setTimeout(() => this.updatePdpBanners(readSelectedId()), delay));
    const productRoot = document.querySelector('.main-product');
    if (productRoot && !document._freeGiftListingObserver) {
      let scheduled = null;
      const observer = new MutationObserver(() => {
        if (this._placingBanner) return;
        window.clearTimeout(scheduled);
        scheduled = window.setTimeout(() => this.updatePdpBanners(readSelectedId()), 80);
      });
      observer.observe(productRoot, { childList: true, subtree: true });
      document._freeGiftListingObserver = true;
    }

    document.addEventListener(
      'change',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (
          target.getAttribute('name') === 'id'
          || target.closest('.main-product, .x-variant-picker, .variant-selects, .x-variants-data, .x-block-app')
        ) {
          requestAnimationFrame(() => this.updatePdpBanners(readSelectedId()));
        }
      },
      true
    );
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element) || !target.closest('.main-product')) return;
        window.setTimeout(() => this.updatePdpBanners(readSelectedId()), 50);
      },
      true
    );

    if (!document._freeGiftBannerHook) {
      const originalDispatch = document.dispatchEvent.bind(document);
      const controller = this;
      document.dispatchEvent = function freeGiftDispatchEvent(event) {
        const result = originalDispatch(event);
        if (event && typeof event.type === 'string' && event.type.includes('variant-select:updated')) {
          const id = event.detail?.currentVariant?.id || readSelectedId();
          controller.updatePdpBanners(id);
        }
        return result;
      };
      document._freeGiftBannerHook = true;
    }
  }

  hidePandaCart() {
    try {
      const alpine = window.Alpine;
      const miniCart = alpine?.store?.('xMiniCart');
      const cartNoti = alpine?.store?.('xCartNoti');
      if (cartNoti) cartNoti.show = false;
      if (miniCart) miniCart.open = false;
      alpine?.store?.('xPopup')?.close?.();
      miniCart?.hideCart?.();
    } catch (error) {}
  }

  harvestQualifyingIds() {
    document.querySelectorAll('[data-free-gift-qualifying]').forEach((el) => {
      String(el.getAttribute('data-free-gift-qualifying') || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
        .forEach((id) => this.qualifyingIds.add(String(id)));
    });
    document.querySelectorAll('[data-unlocks-free-gift="true"][data-variant-id]').forEach((el) => {
      this.qualifyingIds.add(String(el.getAttribute('data-variant-id')));
    });
  }

  selectedProductVariantId() {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return null;
    const input = form.querySelector('input.product-variant-id, input[name="id"]');
    return input?.value ? String(input.value) : null;
  }

  selectedVariantUnlocks() {
    const form = document.querySelector('product-form[data-unlocks-free-gift], form[data-type="add-to-cart-form"]');
    const host = document.querySelector('product-form[data-unlocks-free-gift="true"]')
      || document.querySelector('form[data-type="add-to-cart-form"][data-unlocks-free-gift="true"]');
    if (host) {
    const ids = String(host.getAttribute('data-free-gift-qualifying') || '')
      .split(',')
      .map((id) => id.trim());
      const current = this.selectedProductVariantId();
      return Boolean(current && ids.includes(current));
    }
    const productForm = document.querySelector('product-form') || form;
    if (!productForm) return false;
    const ids = String(productForm.getAttribute('data-free-gift-qualifying') || '')
      .split(',')
      .map((id) => id.trim());
    const current = this.selectedProductVariantId();
    return Boolean(current && ids.includes(current));
  }

  isGiftItem(item) {
    const props = item.properties || {};
    return props._free_gift === 'true' || props._free_gift === true;
  }

  normalizeValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  itemMatchValues(item) {
    const values = new Set();
    const add = (value) => {
      const normalized = this.normalizeValue(value);
      if (normalized) values.add(normalized);
    };
    (item.variant_options || item.options || []).forEach(add);
    (item.options_with_values || []).forEach((option) => add(option.value));
    String(item.variant_title || '')
      .split('/')
      .forEach(add);
    add(item.variant_title);
    add(item.sku);
    return values;
  }

  isGenericMatchValue(value) {
    const normalized = this.normalizeValue(value);
    return (
      !normalized ||
      normalized === 'default title' ||
      /^(black|white|clear|transparent|blue|red|green|grey|gray|gold|silver|natural|pink|purple|yellow|orange|brown|beige|cream|graphite|starlight|midnight|ultramarine)$/.test(
        normalized
      )
    );
  }

  matchingGiftVariants(cart, { allowPdpFallback = false } = {}) {
    const allowed = this.config.variants || [];
    if (!allowed.length) return [];
    const needles = new Set();
    const addNeedles = (values) => {
      values.forEach((value) => {
        if (!this.isGenericMatchValue(value)) needles.add(this.normalizeValue(value));
      });
    };
    this.qualifyingItems(cart).forEach((item) => addNeedles(this.itemMatchValues(item)));
    if (!needles.size && allowPdpFallback) {
      addNeedles(this.pdpMatchValues());
    }
    if (!needles.size) return allowPdpFallback ? allowed : [];
    return allowed.filter((variant) => {
      const giftValues = [variant.title, ...(variant.options || [])]
        .map((value) => this.normalizeValue(value))
        .filter((value) => value && !this.isGenericMatchValue(value));
      return giftValues.some((value) => needles.has(value));
    });
  }

  async openPickerAfterQualifyingAdd() {
    try {
      const cart = await this.fetchCart();
      const gifts = this.giftItems(cart);
      if (gifts.length > 0 && this.pickerConfirmed) return;
      if (gifts.length > 0 && !this.pickerConfirmed) {
        for (const gift of gifts) {
          await this.changeLine(gift.key, 0);
        }
      }
      this.activeGiftVariants = this.matchingGiftVariants(await this.fetchCart(), { allowPdpFallback: true });
      this.schedulePicker('add');
    } catch (error) {
      this.schedulePicker('add');
    }
  }

  async fetchCart() {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`);
    if (!response.ok) throw new Error('cart');
    return response.json();
  }

  async removeGiftItems(gifts) {
    for (const gift of gifts || []) {
      await this.changeLine(gift.key, 0);
    }
  }

  async postCart(url, payload) {
    const config = fetchConfig('json');
    config.body = JSON.stringify(payload);
    const response = await fetch(url, config);
    return response.json();
  }

  refreshCart(parsedState) {
    this.updatingFromGift = true;
    const itemCount = parsedState?.item_count;
    if (typeof itemCount === 'number') {
      document.querySelector('cart-items')?.classList.toggle('is-empty', itemCount === 0);
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', itemCount === 0);
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', itemCount === 0);
    }
    const helper = this.pandaCartHelper();
    if (helper?.reRenderSections) {
      helper.reRenderSections(parsedState?.sections);
      if (typeof itemCount === 'number') helper.currentItemCount = itemCount;
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { detail: { source: 'free-gift' } }));
    }
    if (typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cartData: parsedState });
    }
    this.refreshCartIcon();
    document.querySelector('cart-drawer-items')?.onCartUpdate?.();
    setTimeout(() => {
      this.updatingFromGift = false;
    }, 400);
  }

  cartUI() {
    const helper = this.pandaCartHelper();
    if (helper?.getSectionsToRender) {
      return {
        getSectionsToRender: () => helper.getSectionsToRender(),
        setActiveElement() {},
      };
    }
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  normalizeAddResponse(parsedState) {
    if (parsedState?.key) return parsedState;
    const first = parsedState?.items?.[0];
    if (!first) return parsedState;
    return { ...parsedState, key: first.key, id: first.id };
  }

  openCartDropdown(parsedState) {
    const state = this.normalizeAddResponse(parsedState);
    const notification = document.querySelector('cart-notification');
    const drawer = document.querySelector('cart-drawer');
    try {
      const miniCart = window.Alpine?.store?.('xMiniCart');
      const cartNoti = window.Alpine?.store?.('xCartNoti');
      if (cartNoti?.enable && state) {
        cartNoti.setItem(state);
        return;
      }
      if (miniCart?.openCart) {
        miniCart.openCart();
        return;
      }
      if (notification && typeof notification.renderContents === 'function') {
        notification.renderContents(state || {});
        return;
      }
      if (drawer) {
        if (state?.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          drawer.classList.remove('is-empty');
          drawer.open?.();
        }
      }
    } catch (error) {
      console.error(error);
      notification?.open?.();
      drawer?.open?.();
      window.Alpine?.store?.('xMiniCart')?.openCart?.();
    }
  }

  refreshCartIcon() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    fetch(`${window.location.pathname}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newBubble = html.getElementById('cart-icon-bubble');
        if (newBubble) {
          cartIcon.innerHTML = newBubble.innerHTML;
          return;
        }
        const newContent = html.querySelector('.shopify-section');
        if (newContent) cartIcon.innerHTML = newContent.innerHTML;
      })
      .catch(() => {});
  }

  schedulePicker(mode) {
    this.pickerPending = true;
    document.documentElement.classList.add('free-gift-picker-open');
    document.querySelector('cart-notification')?.close?.();
    this.hidePandaCart();
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    const open = () => this.openPicker({ mode });
    open();
    [50, 250, 500].forEach((ms) => {
      setTimeout(() => {
        if (!this.dialog?.open) open();
        else this.hidePandaCart();
      }, ms);
    });
  }

  giftItems(cart) {
    return (cart.items || []).filter((item) => this.isGiftItem(item));
  }

  qualifyingItems(cart) {
    return (cart.items || []).filter(
      (item) => !this.isGiftItem(item) && this.qualifyingIds.has(String(item.id))
    );
  }

  async sync({ openPickerIfNeeded = true, includeSelectedVariant = false } = {}) {
    if (this.syncing) {
      this.syncQueued = {
        openPickerIfNeeded: Boolean(this.syncQueued?.openPickerIfNeeded || openPickerIfNeeded),
        includeSelectedVariant: Boolean(this.syncQueued?.includeSelectedVariant || includeSelectedVariant),
      };
      return { eligible: false, hasGift: false };
    }
    this.syncing = true;
    try {
      this.harvestQualifyingIds();
      const cart = await this.fetchCart();
      const gifts = this.giftItems(cart);
      const qualifying = this.qualifyingItems(cart);
      const pdpUnlocks = includeSelectedVariant && this.selectedVariantUnlocks();
      const eligible = qualifying.length > 0 || pdpUnlocks;
      const hadGiftBefore = this.hadGift;
      const giftRemoved = Boolean(
        (hadGiftBefore || this.giftRemovedByBuyer) && gifts.length === 0 && eligible
      );

      if (!eligible) {
        if (gifts.length) await this.removeGiftItems(gifts);
        this.hadGift = false;
        this.giftRemovedByBuyer = false;
        this.pickerConfirmed = false;
        this.dismissed = false;
        if (!this.syncQueued) {
          this.pickerPending = false;
          document.documentElement.classList.remove('free-gift-picker-open');
        }
        return this.finishSync(false, false);
      }

      if (gifts.length > 1) {
        await this.removeGiftItems(gifts.slice(1));
      }

      const remainingGifts = this.giftItems(await this.fetchCart());
      if (remainingGifts.length === 1 && remainingGifts[0].quantity !== 1 && !(this.pickerPending && !this.pickerConfirmed)) {
        await this.changeLine(remainingGifts[0].key, 1);
      }

      const cartNow = await this.fetchCart();
      const currentGifts = this.giftItems(cartNow);
      this.hadGift = currentGifts.length > 0;
      if (currentGifts.length === 1) {
        const matched = this.matchingGiftVariants(cartNow, { allowPdpFallback: false });
        const currentId = String(currentGifts[0].id || currentGifts[0].variant_id);
        const stillValid = matched.some((variant) => String(variant.id) === currentId);
        const unconfirmedAutoGift = this.pickerPending && !this.pickerConfirmed;

        if (stillValid && !unconfirmedAutoGift) {
          this.dismissed = false;
          const wasPending = this.pickerPending;
          this.pickerPending = false;
          document.documentElement.classList.remove('free-gift-picker-open');
          if (wasPending) this.openCartDropdown();
          return this.finishSync(true, true);
        }

        await this.removeGiftItems(currentGifts);
        this.hadGift = false;
        this.pickerConfirmed = false;
        this.dismissed = false;
        this.giftRemovedByBuyer = false;
        const cartAfterRemove = await this.fetchCart();
        this.activeGiftVariants = this.matchingGiftVariants(cartAfterRemove, { allowPdpFallback: true });
        if (!this.activeGiftVariants.length) {
          this.activeGiftVariants = this.config.variants || [];
        }
        if (this.activeGiftVariants.length > 0) {
          this.schedulePicker('add');
        }
        return this.finishSync(true, false);
      }

      this.activeGiftVariants = this.matchingGiftVariants(cartNow, { allowPdpFallback: true });
      if (!this.activeGiftVariants.length && (giftRemoved || this.giftRemovedByBuyer || hadGiftBefore)) {
        this.activeGiftVariants = this.config.variants || [];
      }

      if (
        this.activeGiftVariants.length > 0 &&
        (this.pickerPending || giftRemoved || hadGiftBefore || (openPickerIfNeeded && !this.dismissed))
      ) {
        this.dismissed = false;
        this.pickerConfirmed = false;
        this.giftRemovedByBuyer = false;
        this.schedulePicker('add');
      }

      return this.finishSync(true, false);
    } catch (error) {
      console.error(error);
      return this.finishSync(false, false);
    } finally {
      this.syncing = false;
      if (this.syncQueued) {
        const queued = this.syncQueued;
        this.syncQueued = false;
        this.sync(queued);
      }
    }
  }

  finishSync(eligible, hasGift) {
    this.hadGift = Boolean(hasGift);
    this.refreshPdpBanner();
    return { eligible, hasGift };
  }

  async changeLine(key, quantity) {
    const helper = this.pandaCartHelper();
    try {
      await this.waitForPandaCart();
    } catch (error) {}
    window.updatingCart = true;
    this.updatingFromGift = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const sectionIds = helper?.getSectionsToRender?.()?.map((section) => section.id) || [];
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity,
          sections: sectionIds,
          sections_url: window.location.pathname,
        }),
      });
      const parsedState = await response.json();
      if (parsedState.status) throw new Error(parsedState.description || parsedState.message);
      this.refreshCart(parsedState);
      return parsedState;
    } finally {
      window.updatingCart = false;
      setTimeout(() => {
        this.updatingFromGift = false;
      }, 400);
    }
  }

  async addGift(variantId) {
    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    formData.append('properties[_free_gift]', 'true');
    const cart = this.cartUI();
    const pandaSections = this.pandaCartHelper()?.getSectionsToRender?.();
    const sectionIds = pandaSections?.length
      ? pandaSections.map((section) => section.id)
      : [
          'cart-notification-product',
          'cart-notification-button',
          'cart-icon-bubble',
          ...(cart?.getSectionsToRender ? cart.getSectionsToRender().map((section) => section.id) : []),
        ];
    formData.append('sections', [...new Set(sectionIds)].join(','));
    formData.append('sections_url', window.location.pathname);
    cart?.setActiveElement?.(document.activeElement);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
    const response = await fetch(window.routes.cart_add_url || '/cart/add.js', config);
    const parsedState = await response.json();
    if (parsedState.status) {
      throw new Error(parsedState.description || parsedState.message || window.cartStrings?.error);
    }
    this.refreshCart(parsedState);
    return parsedState;
  }

  async replaceGift(variantId) {
    const cart = await this.fetchCart();
    const gifts = this.giftItems(cart);
    for (const gift of gifts) {
      await this.changeLine(gift.key, 0);
    }
    await this.addGift(variantId);
  }

  bindDialog() {
    if (!this.dialog) return;
    this.dialog.querySelectorAll('[data-free-gift-close]').forEach((button) => {
      button.addEventListener('click', () => this.closePicker(false));
    });
    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.closePicker(false);
    });
    this.submitButton?.addEventListener('click', () => this.submitPicker());
  }

  bindPrompts() {
    document.querySelectorAll('[data-free-gift-open]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.openPicker({ mode: 'add' });
      });
    });
  }

  buildOptions() {
    const variants = this.activeGiftVariants || this.config.variants || [];
    if (!this.optionsEl || !variants.length) return;
    if (variants.length) {
      this.config.options = (this.config.options || []).map((option, index) => ({
        name: option.name,
        values: [
          ...new Set(
            variants
              .map((variant) => variant.options?.[index])
              .filter((value) => value != null && String(value).trim() !== '')
          ),
        ],
      })).filter((option) => option.values.length > 0);
    }
    if (!this.config.options?.length) return;
    this.optionsEl.innerHTML = '';
    this.selectedOptions = this.config.options.map((option) => option.values[0]);
    this.config.options.forEach((option, index) => {
      const wrapper = document.createElement('div');
      if (option.values.length === 1) {
        const value = document.createElement('p');
        value.className = 'free-gift-dialog__option-value';
        value.textContent = option.values[0];
        wrapper.appendChild(value);
      } else {
        const select = document.createElement('select');
        select.className = 'free-gift-dialog__select select__select';
        select.id = `FreeGiftOption-${index}`;
        select.setAttribute('aria-label', option.name);
        option.values.forEach((value) => {
          const opt = document.createElement('option');
          opt.value = value;
          opt.textContent = value;
          select.appendChild(opt);
        });
        select.addEventListener('change', () => {
          this.selectedOptions[index] = select.value;
          this.updatePickerState();
        });
        wrapper.appendChild(select);
      }
      this.optionsEl.appendChild(wrapper);
    });
    this.updatePickerState();
  }

  findVariant() {
    const pool = this.activeGiftVariants || this.config.variants || [];
    if (this.config.hasOnlyDefaultVariant || pool.length <= 1) {
      return pool.find((variant) => variant.available) || pool[0];
    }
    const selected = this.selectedOptions.map((value) => String(value).trim().toLowerCase());
    return pool.find((variant) =>
      (variant.options || []).every((value, index) => String(value).trim().toLowerCase() === selected[index])
    );
  }

  updatePickerState() {
    const variant = this.findVariant();
    if (this.image && variant?.featuredImage) {
      this.image.src = variant.featuredImage;
    }
    if (this.priceEl) {
      this.priceEl.textContent = variant?.price || this.config.price || '';
    }
    if (!this.submitButton) return;
    if (!variant || !variant.available) {
      this.submitButton.disabled = true;
      this.submitButton.textContent = variant
        ? this.strings().sold_out
        : this.strings().unavailable;
    } else {
      this.submitButton.disabled = false;
      this.submitButton.textContent =
        this.mode === 'change' ? this.strings().change : this.strings().add;
    }
  }

  strings() {
    const button = this.submitButton;
    return {
      add: button?.dataset.labelAdd || 'Add free gift',
      change: button?.dataset.labelChange || 'Change gift',
      sold_out: button?.dataset.labelSoldOut || 'Sold out',
      unavailable: button?.dataset.labelUnavailable || 'Unavailable',
      error: button?.dataset.labelError || 'Could not add the free gift. Try another option.',
    };
  }

  showError(message) {
    if (!this.errorEl) return;
    this.errorEl.hidden = !message;
    this.errorEl.textContent = message || '';
  }

  stopConfetti() {
    if (this._confettiRaf) {
      cancelAnimationFrame(this._confettiRaf);
      this._confettiRaf = 0;
    }
    const canvas = this._confettiCanvas;
    this._confettiCanvas = null;
    if (!canvas) return;
    try {
      canvas.hidePopover?.();
    } catch (error) {}
    canvas.remove();
  }

  launchConfetti() {
    if (!this.dialog) return;

    this.stopConfetti();

    const width = window.innerWidth;
    const height = window.innerHeight;
    const canvas = document.createElement('canvas');
    canvas.className = 'free-gift-confetti';
    canvas.setAttribute('aria-hidden', 'true');

    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.floor(width * dpr);
    canvas.height = Math.floor(height * dpr);
    canvas.style.cssText = [
      'position:fixed',
      'inset:0',
      'top:0',
      'left:0',
      `width:${width}px`,
      `height:${height}px`,
      'max-width:none',
      'max-height:none',
      'margin:0',
      'padding:0',
      'border:none',
      'background:transparent',
      'pointer-events:none',
      'z-index:2147483647',
    ].join(';');

    let overlay = false;
    if (typeof canvas.showPopover === 'function') {
      canvas.setAttribute('popover', 'manual');
      document.body.appendChild(canvas);
      try {
        canvas.showPopover();
        overlay = true;
      } catch (error) {
        canvas.removeAttribute('popover');
        this.dialog.appendChild(canvas);
      }
    } else {
      this.dialog.appendChild(canvas);
    }
    this._confettiCanvas = canvas;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const rect = this.dialog.getBoundingClientRect();
    const toCanvasX = (x) => (overlay ? x : x - rect.left);
    const toCanvasY = (y) => (overlay ? y : y - rect.top);
    const drawWidth = overlay ? width : Math.max(rect.width, 1);
    const drawHeight = overlay ? height : Math.max(rect.height, 1);
    if (!overlay) {
      canvas.width = Math.floor(drawWidth * dpr);
      canvas.height = Math.floor(drawHeight * dpr);
      canvas.style.width = `${drawWidth}px`;
      canvas.style.height = `${drawHeight}px`;
      canvas.style.position = 'absolute';
      canvas.style.inset = '0';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    const colors = ['#F43F5E', '#F59E0B', '#22C55E', '#3B82F6', '#A855F7', '#EC4899', '#FDE047'];
    const particles = [];
    const spawn = (originX, originY, angleDeg, count, spreadDeg = 70) => {
      const angle = (angleDeg * Math.PI) / 180;
      for (let i = 0; i < count; i++) {
        const spread = ((Math.random() - 0.5) * spreadDeg * Math.PI) / 180;
        const speed = 7 + Math.random() * 12;
        particles.push({
          x: toCanvasX(originX),
          y: toCanvasY(originY),
          vx: Math.cos(angle + spread) * speed,
          vy: Math.sin(angle + spread) * speed,
          w: 8 + Math.random() * 7,
          h: 10 + Math.random() * 8,
          rot: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.45,
          color: colors[i % colors.length],
          life: 1,
          decay: 0.007 + Math.random() * 0.008,
          shape: Math.random() > 0.3 ? 'rect' : 'circle',
        });
      }
    };

    const leftX = rect.left;
    const rightX = rect.right;
    const midX = rect.left + rect.width / 2;
    const midY = rect.top + rect.height * 0.5;
    const bottomY = rect.bottom;

    spawn(leftX, bottomY, -55, 90);
    spawn(rightX, bottomY, -125, 90);
    spawn(midX, midY, -90, 70, 360);

    const gravity = 0.2;
    const drag = 0.99;
    const draw = () => {
      ctx.clearRect(0, 0, drawWidth, drawHeight);
      let alive = false;
      for (let i = 0; i < particles.length; i++) {
        const p = particles[i];
        p.vy += gravity;
        p.vx *= drag;
        p.vy *= drag;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        p.life -= p.decay;
        if (p.life <= 0) continue;
        alive = true;
        ctx.save();
        ctx.globalAlpha = Math.max(p.life, 0);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.shape === 'circle') {
          ctx.beginPath();
          ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
        ctx.restore();
      }
      if (alive) {
        this._confettiRaf = requestAnimationFrame(draw);
      } else {
        this.stopConfetti();
      }
    };

    this._confettiRaf = requestAnimationFrame(draw);
  }

  openPicker({ mode = 'add' } = {}) {
    this.mode = mode;
    this.pickerPending = true;
    this.showError('');
    this.buildOptions();
    this.updatePickerState();
    document.documentElement.classList.add('free-gift-picker-open');
    document.querySelector('cart-notification')?.close?.();
    this.hidePandaCart();
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    if (!this.dialog) return;
    if (this.dialog.parentElement !== document.body) {
      document.body.appendChild(this.dialog);
    }
    const alreadyOpen = Boolean(this.dialog.open);
    try {
      if (typeof this.dialog.showModal === 'function') {
        if (!this.dialog.open) this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    } catch (error) {
      this.dialog.setAttribute('open', '');
    }
    if (!alreadyOpen) {
      requestAnimationFrame(() => this.launchConfetti());
    }
    this.submitButton?.focus();
  }

  closePicker(completed) {
    this.stopConfetti();
    document.documentElement.classList.remove('free-gift-picker-open');
    if (this.dialog?.open) this.dialog.close();
    this.dialog?.removeAttribute('open');
    this.pickerPending = false;
    if (!completed) {
      this.dismissed = true;
      if (this.checkoutResolver) {
        this.checkoutResolver(false);
        this.checkoutResolver = null;
      }
      this.openCartDropdown();
    }
  }

  async submitPicker() {
    const variant = this.findVariant();
    if (!variant) {
      this.showError(this.strings().unavailable);
      return;
    }
    if (!variant.available) {
      this.showError(this.strings().sold_out);
      return;
    }
    this.submitButton.disabled = true;
    this.showError('');
    try {
      const parsedState =
        this.mode === 'change' ? await this.replaceGift(variant.id) : await this.addGift(variant.id);
      this.dismissed = false;
      this.pickerConfirmed = true;
      this.hadGift = true;
      this.closePicker(true);
      this.refreshPdpBanner();
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      setTimeout(() => this.openCartDropdown(parsedState), 150);
      if (this.checkoutResolver) {
        this.checkoutResolver(true);
        this.checkoutResolver = null;
      }
    } catch (error) {
      const message = typeof error?.message === 'string' ? error.message : this.strings().error;
      this.showError(message.includes('innerHTML') ? this.strings().error : message);
    } finally {
      this.updatePickerState();
    }
  }

  waitForPicker() {
    return new Promise((resolve) => {
      this.checkoutResolver = resolve;
      this.openPicker({ mode: 'add' });
    });
  }

  async ensureBeforeCheckout({ includeSelectedVariant = false } = {}) {
    const state = await this.sync({
      openPickerIfNeeded: false,
      includeSelectedVariant,
    });
    if (!state.eligible || state.hasGift) return true;
    return this.waitForPicker();
  }

  wrapGokwik() {
    const wrap = (name, includeSelectedVariant) => {
      const original = window[name];
      if (typeof original !== 'function' || original._freeGiftWrapped) return;
      const controller = this;
      const wrapped = async function wrappedGokwik() {
        const ok = await controller.ensureBeforeCheckout({ includeSelectedVariant });
        if (ok) return original.apply(this, arguments);
      };
      wrapped._freeGiftWrapped = true;
      window[name] = wrapped;
    };

    const tryWrap = () => {
      wrap('onBuyNowClick', true);
      wrap('onCheckoutClick', false);
      try {
        const helper = window.Alpine?.store?.('xCartHelper');
        if (helper?.goToCheckout && !helper.goToCheckout._freeGiftWrapped) {
          const original = helper.goToCheckout.bind(helper);
          const controller = this;
          const wrappedCheckout = async function wrappedPandaCheckout(e) {
            const ok = await controller.ensureBeforeCheckout({ includeSelectedVariant: false });
            if (ok) return original(e);
            e?.preventDefault?.();
          };
          wrappedCheckout._freeGiftWrapped = true;
          helper.goToCheckout = wrappedCheckout;
        }
      } catch (error) {}
    };

    tryWrap();
    window.addEventListener('gokwikLoaded', tryWrap);
    document.addEventListener('DOMContentLoaded', tryWrap);
    document.addEventListener('alpine:init', tryWrap);

    document.addEventListener(
      'click',
      async (event) => {
        const button = event.target.closest('button[name="checkout"]');
        if (!button || button.closest('.gokwik-checkout')) return;
        if (this.allowNativeCheckout) return;
        event.preventDefault();
        event.stopPropagation();
        const ok = await this.ensureBeforeCheckout({ includeSelectedVariant: false });
        if (ok) {
          this.allowNativeCheckout = true;
          button.click();
          this.allowNativeCheckout = false;
        }
      },
      true
    );
  }
}

function initFreeGift() {
  const node = document.getElementById('FreeGiftConfig');
  if (!node) return;
  let config;
  try {
    config = JSON.parse(node.textContent);
  } catch (error) {
    return;
  }
  if (!config?.enabled) return;
  window.freeGiftController = new FreeGiftController(config);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFreeGift);
} else {
  initFreeGift();
}
